/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_WebglInputs */

const en_fc_online_webgl = /** @type {(inputs: Fc_Online_WebglInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Having trouble? Try WebGL mode`)
};

/**
* | output |
* | --- |
* | "Having trouble? Try WebGL mode" |
*
* @param {Fc_Online_WebglInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_webgl = /** @type {((inputs?: Fc_Online_WebglInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_WebglInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_webgl(inputs)
});
export { fc_online_webgl as "fc.online.webgl" }